namespace GeniuzPOS.Lookups {
    export interface LookupSubCategory1Row {
        SubCat1Code?: string;
        SubCat1Name?: string;
    }

    export namespace LookupSubCategory1Row {
        export const idProperty = 'SubCat1Code';
        export const nameProperty = 'SubCat1Code';
        export const localTextPrefix = 'Lookups.LookupSubCategory1';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name"
        }
    }
}
